import React, { useEffect, useMemo, useState } from "react";
import { useAsync } from "react-use";
import { SwaggerAPI } from "@/api/hunger.api";
import { isNotSet } from "@/tools/format.checker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StoreSelector from "@/components/MainFlow/Dashboard/Feature/StoreSelector";
import classNames from "classnames";

export const StoreSwitch: React.FC<{
  storeId: number | null;
  onStoreChange: (storeId: number) => void;
  className?: string;
}> = ({ storeId, onStoreChange, className }) => {
  const [showSelector, setShowSelector] = useState<boolean>(false);

  const { value: stores } = useAsync(async () => {
    const { data } = await SwaggerAPI.getStores();
    return data;
  }, []);

  useEffect(() => {
    if (stores && isNotSet(storeId)) {
      // set default store
      onStoreChange(stores[0].id);
    }
  }, [stores, storeId]);

  const currentStore = useMemo(
    () => stores?.find(({ id }) => id === storeId),
    [storeId]
  );

  return (
    <React.Fragment>
      {showSelector && (
        <StoreSelector
          stores={stores ?? []}
          onChange={onStoreChange}
          value={storeId}
          close={() => setShowSelector(false)}
        />
      )}
      <button
        type="button"
        onClick={() => setShowSelector(true)}
        className={classNames(
          className,
          "flex items-center",
          "py-3 px-5",
          "w-full",
          "bg-white rounded-lg"
        )}
      >
        <div
          className={
            "flex items-center justify-center mr-4 w-9 h-9 rounded-lg overflow-hidden bg-grey-5"
          }
        >
          {currentStore?.logoPhotoFile ? (
            <img
              src={currentStore?.logoPhotoFile.url}
              alt={"logo"}
              className={"w-full h-full object-cover"}
            />
          ) : (
            <FontAwesomeIcon icon={["fad", "store"]} />
          )}
        </div>
        <p className={"mr-auto text-lg text-grey-2 font-semibold"}>
          {currentStore?.name}
        </p>
        <p className={"text-base font-semibold text-primary-pink"}>
          <FontAwesomeIcon icon={["far", "exchange"]} className={"mr-2"} />
          切換
        </p>
      </button>
    </React.Fragment>
  );
};
